module.exports = __webpack_public_path__ + "img/06.01c06221.png";